import { Icon } from '@iconify/react';
import { useEffect, useState } from 'react';
// material
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Tooltip
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
// react icons
// material icons
// other icons
import searchFill from '@iconify/icons-eva/search-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
import { RootStyle, SearchStyle } from '../Global/Styling';
// ---------------------------------------------------------
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
// ----------------------------------------------------------------------

export default function AppointmentToolbar({
  numSelected,
  filterName,
  onFilterName,
  parent,
  setAddAppointment,
  setAddEditAppointmentTitle,
  setFromdate,
  setTableRowsNamse,
  fromDate,
  allLeadList,
  selectLead,
  setSelectLead,
  setAddEditAppointment
}) {
  const navigate = useNavigate();
  const [isOpenFilter, openFilter] = useState(false);
  const [filterDatesRange, setFilterDatesRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ]);
  useEffect(() => {}, [fromDate]);
  return (
    <>
      {isOpenFilter && (
        <Box px={3} pt={2}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3}>
              <Select
                id="Lead"
                fullWidth
                disabled
                onChange={(e) => setSelectLead(e.target.value)}
                value={selectLead}
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${selectLead}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Lead
                </MenuItem>
                {allLeadList.length > 0 &&
                  allLeadList.map((leadItem, leadIndex) => {
                    const itemValue = {
                      leadId: leadItem.leadId,
                      customerName: leadItem.customerName
                    };
                    return <MenuItem value={itemValue.leadId}>{itemValue.customerName}</MenuItem>;
                  })}
              </Select>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id=""
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Select Date"
                type="date"
                defaultValue={fromDate}
                onChange={(e) => {
                  setFromdate(e.target.value);
                  setTableRowsNamse([]);
                }}
              />
            </Grid>
          </Grid>
        </Box>
      )}

      <RootStyle
        sx={{
          height: { xs: 'auto', md: 45 },
          minHeight: 45,
          borderBottom: '1px solid #eaedf1',
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'flex-start', md: 'center' },
          gap: 2,
          padding: { xs: 2, md: 0 }
        }}
      >
        <Box>
          <Button
            variant="contained"
            onClick={(e) => {
              setAddAppointment(true);
              setAddEditAppointmentTitle('Add Appointment');
              setAddEditAppointment({
                lead: ' ',
                purpose: '',
                appointmentType: ' ',
                name: '',
                mobile: '',
                appointmentDate: '',
                addressType: ' ',
                address: '',
                landmark: '',
                state: null,
                city: null,
                pin: '',
                comments: ''
              });
            }}
            sx={{
              bgcolor: '#13519d',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 600,
              boxShadow: '0 4px 14px rgba(19,81,157,0.25)',
              '&:hover': { bgcolor: '#0d3b75' }
            }}
          >
            New Appointment
          </Button>
        </Box>
        <Box display="flex" alignItems="center" gap={1} sx={{ width: { xs: '100%', md: 'auto' } }}>
          <SearchStyle
            value={filterName}
            onChange={onFilterName}
            disabled
            placeholder="Search Appointment"
            sx={{ width: { xs: '100%', md: 240 } }}
            classes={{
              root: 'searchHolder',
              input: 'searchInput'
            }}
            startAdornment={
              <InputAdornment position="start">
                <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            }
          />
          <Tooltip title="Filter list">
            <IconButton
              onClick={(e) => {
                openFilter(!isOpenFilter);
              }}
            >
              <Icon icon={roundFilterList} />
            </IconButton>
          </Tooltip>
        </Box>
      </RootStyle>
    </>
  );
}
